import { CloseOutlined } from '@mui/icons-material'

import {
  Box,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { isBusinessURL } from '../../../_helpers/routes'
import { ITab } from '../../../_models/tabsInterface'
import LanguageSelector from '../../../components/languageSelector'
import { headerTabs } from '../items'

interface IMainDrawerProps {
  windowParam?: () => Window
  handleDrawerToggle: () => void
  mobileOpen: boolean
}

const MainDrawer = (props: IMainDrawerProps) => {
  const { t } = useTranslation()
  const { windowParam, handleDrawerToggle, mobileOpen } = props
  const container = windowParam !== undefined ? () => windowParam().document.body : undefined
  const navigate = useNavigate()
  const drawerWidth = '100vw'

  const handleClickOnListItem = (item: ITab) => {
    handleDrawerToggle()
    if (isBusinessURL()) {
      window.location.replace(
        `${window.location.protocol}//${process.env.REACT_APP_BUSINESS_URL}${item.path}`,
      )
    } else navigate(item.path)
  }
  // Drawer - mobile view
  const drawer = (
    <>
      <Box onClick={handleDrawerToggle} sx={{ textAlign: 'end' }}>
        <Box>
          <IconButton
            color='primary'
            aria-label='open drawer'
            edge='end'
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { lg: 'none' } }}
          >
            <CloseOutlined />
          </IconButton>
        </Box>

        <List>
          {headerTabs.map((item: ITab) => (
            <ListItem key={item.id}>
              <ListItemButton
                sx={{ textAlign: 'center' }}
                onClick={() => handleClickOnListItem(item)}
              >
                <ListItemText primary={t(`publicLayout.${item.label}`)} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
      <Stack sx={{ mx: 4 }}>
        <Box mb={2} display={'flex'} justifyContent={'center'}>
          <LanguageSelector />
        </Box>
      </Stack>
    </>
  )
  return (
    <>
      <Drawer
        container={container}
        variant='temporary'
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: 'block', lg: 'none' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
        }}
      >
        {drawer}
      </Drawer>
    </>
  )
}

export default MainDrawer
